import Flickity from "flickity";
import "flickity/css/flickity.css";

(function (Drupal) {
  Drupal.behaviors.nodeServicios = {
    attach: function (context, settings) {
      const elem = document.querySelector(".slider-especialistas-sec");

      // Detectar si el dispositivo es móvil
      const deviceDetect = {
        breakpointDesktop: 767,
        isMobile: () => {
          return window.matchMedia(`(max-width: ${deviceDetect.breakpointDesktop - 1}px)`).matches;
        },
      };

      if (elem) {
        new Flickity(elem, {
          cellAlign: "left",
          contain: true,
          pageDots: false, // Ocultar los dots en móvil
          prevNextButtons: !deviceDetect.isMobile(), // Ocultar los botones en móvil
          groupCells: deviceDetect.isMobile() ? 1 : 3,
        });
      }

      if (document.querySelector(".slider-especialistas-sec")) {
        const sliderContainer = document.querySelector(".slider-especialistas-sec");
        const flickityViewport = sliderContainer.querySelectorAll(".flickity-viewport");
        const carouselCell = sliderContainer.querySelectorAll(".carousel-cell");

        if (carouselCell.length > 0) {
          // Inicializa la variable para almacenar la altura máxima
          let maxHeight = 0;

          // Encuentra la altura más alta
          carouselCell.forEach(function (field) {
            const fieldHeight = field.offsetHeight;
            if (fieldHeight > maxHeight) {
              maxHeight = fieldHeight;
            }
          });

          // Asigna la altura a la clase que contiene el slide
          flickityViewport.forEach(function (container) {
            container.style.height = maxHeight + 10 + "px";
          });

          // Asigna la altura máxima a todos los divs con la clase carousel-cell
          carouselCell.forEach(function (field) {
            field.style.height = maxHeight + "px";
          });
        }
      }
    },
  };
})(Drupal);
